<template>
  <div>
    <b-row class="mb-3">
      <b-col cols="12">
        <PageHeader :title="$cte('cashFlow.title')" />
      </b-col>
    </b-row>
    <b-tabs v-model="activeTab" card pills class="d-none">
      <b-tab
          :title="$cte('common.uploads')"
          class="bg-white pt-1 m-0 p-0"
          style=""
      >
      </b-tab>
    </b-tabs>
    <cash-flow-list />
  </div>
</template>

<script>
import PageHeader from "../../../components/PageHeader";
import Util from "@/utils/Util";
import CashFlowList from "@/views/app/cashflow/CashFlowList.vue";

export default {
  name: "CashFlow",

  components: {
    CashFlowList,
    PageHeader
  },

  data() {
    return {
      activeTab: 0,
    }
  },

  watch: {
    activeTab() {
      Util.storeGlobalData('cashFlow-active-tab', this.activeTab);
    }
  },

  created() {
    let previousActiveTab = Util.getGlobalData('cashFlow-active-tab');
    if (previousActiveTab) {
      this.activeTab = previousActiveTab;
    }
  },
}
</script>

<style scoped>

</style>